import { render } from "./multi-store.vue?vue&type=template&id=0a57c93e"
import script from "./multi-store.vue?vue&type=script&lang=js"
export * from "./multi-store.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__